.breadcrumb {
  font-family: inherit;
  padding-bottom: 4px;
  padding-left: 48px;
  padding-top: 4px;
}

.breadcrumbList,
.breadcrumbItem,
.breadcrumbSeparator {
  align-items: center;
}

.breadcrumbList {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 0;
  padding: 0;
}

.breadcrumbItem,
.breadcrumbSeparator {
  display: flex;
}

.breadcrumbSeparator {
  color: var(--pgm-sys-color-outline);
  margin-left: 4px;
  margin-right: 4px;
}

.breadcrumbChevron {
  font-size: 16px;
  height: 16px;
  line-height: 16px;
  width: 16px;
}

.breadcrumb .breadcrumbLink,
.breadcrumb .breadcrumbCurrent {
  vertical-align: middle;
}

.breadcrumb .breadcrumbLink {
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-thickness: auto;
  text-underline-offset: 0;
  text-decoration-skip-ink: auto;
}

.breadcrumb .breadcrumbHomeLink {
  text-decoration: none;
}

.breadcrumb .breadcrumbCurrent {
  color: var(--pgm-sys-color-on-surface);
  text-decoration: none;
}

.breadcrumbHomeIcon {
  display: block;
  height: 20px;
  font-size: 20px;
  font-variation-settings:
    "FILL" 1,
    "wght" 400,
    "GRAD" 0,
    "opsz" 20;
  line-height: 20px;
  width: 20px;
}
